'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var arrayLikeToArray = require('./arrayLikeToArray.js');

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray['default'](arr);
}

exports['default'] = _arrayWithoutHoles;